import { DetectedPlatform } from './types'

/** Brand names are never translated, so they are interpolated rather than stored as copy. */
export const PLATFORM_BRAND_NAME: Record<DetectedPlatform, string> = {
  slack: 'Slack',
  microsoft: 'Microsoft',
  google: 'Google',
}
